import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@stackje/shared-components/ui/dialog';
import { CustomColorPicker } from './CustomColorPicker';
interface CustomColorPickerDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onColorSchemeSelect: (colors: string[]) => void;
  title?: string;
  initialColors?: string[];
}

export const CustomColorPickerDialog: React.FC<CustomColorPickerDialogProps> = ({
  open,
  onOpenChange,
  onColorSchemeSelect,
  title = "Custom Color Scheme",
  initialColors
}) => {
  const handleCancel = () => {
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md w-[95vw] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <CustomColorPicker
          onColorSchemeSelect={onColorSchemeSelect}
          onCancel={handleCancel}
          initialColors={initialColors}
        />
      </DialogContent>
    </Dialog>
  );
};